import { makeStyles, TextField, withStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { fontSize } from '@material-ui/system';

const RetrackInputRhf = ({
    name,
    defaultValue = '',
    textFieldStyle,
    showError = true,
    readOnly = false,
    disabled = false,
    isWrapError = false,
    width = '100%',
    paddingTop = 0,
    color = 'black',
    fontSize = '16px',
    readFontSize = '28px',
    readColor = 'blue',
}) => {
    const {
        formState: { errors, defaultValues },
        control,
    } = useFormContext();
    return (
        <div style={{ display: 'flex', flexDirection: isWrapError ? 'column' : 'row' }}>
            <Controller
                control={control}
                name={name}
                render={({ field }) => (
                    <input
                        {...field}
                        readOnly={readOnly}
                        disabled={disabled}
                        style={{
                            border: 'none',
                            outline: 'none',
                            backgroundColor: 'transparent',
                            borderBottom: '1px solid #000',
                            width: width,
                            paddingTop: paddingTop,
                            boxSizing: 'border-box',
                            fontWeight: 900,
                            fontSize: readOnly ? readFontSize : fontSize,
                            textAlign: 'center',
                            color: readOnly ? readColor : color,
                        }}
                        // onFocus={(e) => e.target.style.borderBottom = '2px solid black'}
                        // onBlur={(e) => e.target.style.borderBottom = '1px solid #000'}
                    />
                )}
                defaultValue={defaultValue}
            />
            {showError && (
                <div style={{ marginLeft: 8 }}>
                    <ErrorMessage
                        errors={errors}
                        name={name}
                        render={({ message }) => <div style={{ color: 'red' }}>{message}</div>}
                    />
                </div>
            )}
        </div>
    );
};

export default RetrackInputRhf;
